// Separate podcast bundle for LOSWP to keep the main fast_loswp bundle smaller

import { initializePodcastPlayers } from 'js/podcast_ai/lazyPodcastLoader';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePodcastPlayers);
} else {
  initializePodcastPlayers();
}
